let overrideConfig = {}
let themeConfig = null

let defaultConfig = {
  "THEME": "",
  "mock": false,
  "filter": null,
  "store": null,
  "SENTRY": false,
  "SENTRY_DSN": "",
  'SENTRY_ENV':'Development',
  'SENTRY_GITHASH': '',
  "FEATURE_PREPAREBOXES": false,
  "FEATURE_PASTORDERS": false,
  // HACK: currently true, but will be false soon
  "FEATURE_ORDERBOXES": true, 
  "MOCK_ORDERS_FILE": "/mockdata/orders-nooch.json",
  "PASTORDERS_LIMIT": 50,
  "ORDERBOX_COLUMNS": 3,
  "ORDERBOXES": 6,
  "ORDERBOXES_FILLBOTTOM_FIRST": false,
  "ORDERBOXES_ADVANCE_TO_PREPBOX": false,
  "ORDER_STATUS_PICKUP_PREFIX": "in_box_",
  "ORDER_STATUS_PREP_PREFIX": "in_prep_",
  "ORDER_STATUS": ["new", "in_production", "in_prep_1", "in_prep_2", "in_prep_3", "in_prep_4", "in_prep_5", "in_prep_6", "in_box_1", "in_box_2", "in_box_3", "in_box_4", "in_box_5", "in_box_6", "done"],
  "ORDERLIST_API_RETRIES": 20,
  "THEME_LOGO": "images/logo_missmiu_pink.png",
  "THEME_PAYMENT_ARROW": 'images/arrowDown-missmiu.svg',
  "LANG_ORDERS_NEW": "Neue Bestellungen",
  "LANG_ORDERS_PREP": "In Vorbereitung",
  "LANG_ORDERS_PREP_BOX": "In Vorbereitungsboxen",
  "LANG_ORDERS_PICKUP": "Abholbereit",
}

export function readFromUrl(config) {
  //read url parameters
  var urlCfgMap = {
    'status': 'filter',
    'mock': 'mock',
    'store': 'store'
  }
  var urlCfg = (window.location.search
    .split("?")[1] || "")
    .split("&")
    .map(v => v.split("="))
    .reduce((p, c) => {
      let envKey = urlCfgMap[c[0]]
      if (envKey) {
        p[envKey] = c[1]
      }
      return p
    }, {})
  return urlCfg
}
export function readFromHtml(config) {
  var d = document.querySelector("script[data-config]")
  if (d) {
    var json = JSON.parse(d.innerHTML.replace(/^\s+/, ""))
    json.LANG_ORDERS_PICKUP = json.LANG_ORDERS_PICKUP || config.LANG_ORDERS_PICKUP
    json.ORDERBOXES = json.ORDERBOXES || config.ORDERBOXES
    if (json) {
      return json
    }
    
  }
  return {}
}

export function setConfigValue(key, value) {
  overrideConfig[key] = value
  updateConfig()
}
export function setThemeConfig(config) {
  themeConfig = config
  updateConfig()
}

export function updateConfig() {
  let config = cfg || defaultConfig
  Object.assign(config, overrideConfig)
//  Object.assign(config, configDev)
  Object.assign(config, themeConfig)
  Object.assign(config, readFromUrl(config))
//  Object.assign(config, readFromDev(config))
  Object.assign(config, readFromHtml(config))
//  Object.assign(config, readFromRemote(config))
  Object.assign(config, readFromUrl(config))
  Object.assign(config, overrideConfig)
  console.log(config, overrideConfig)
  return config
}

var cfg = updateConfig()
export const config = cfg
//export default config
